<template>
    <v-container fluid grid-list-md>
        <v-layout wrap>
            <v-flex xs12>
                <h4>Отчеты</h4>
            </v-flex>
            <v-flex xs12 sm12 md12>
                <v-data-table
                        :items="reports.results"
                        :server-items-length="reports.last_page"
                        :loading="listLoading.includes('reportingFetchReports')"
                        hide-default-footer
                        :headers="headers"
                        no-results-text="Нет отфильтрованных данных"
                        class="elevation-1">
                    <template v-slot:header.action="{ header }">
                        <v-tooltip bottom open-delay="500">
                            <template v-slot:activator="{ on }">
                                <v-btn
                                        :to="{name: 'reporting_report', params: {'report_id': 'new'}}"
                                        class="mr-2"
                                        icon
                                        v-on="on"
                                >
                                    <v-icon>mdi-pencil-plus</v-icon>
                                </v-btn>
                            </template>
                            <span>Создать отчет</span>
                        </v-tooltip>
                    </template>
                    <template v-slot:body.prepend>
                        <tr>
                            <td>
                                <v-text-field
                                        v-model="report_search.period"
                                        type="month"
                                ></v-text-field>
                            </td>
                            <td>
                                <v-autocomplete
                                        v-bind:items="statuses"
                                        item-text="status_name"
                                        item-value="id"
                                        v-model="report_search.status_id"
                                        :loading="listLoading.includes('reportingFetchStatuses')"
                                >
                                </v-autocomplete>
                            </td>
                            <td>
                                <v-text-field v-model.trim="report_search.department"></v-text-field>
                            </td>
                            <td>
                                <v-btn
                                        icon
                                        class="mr-2"
                                        @click="initialize()"
                                >
                                    <v-icon>mdi-magnify</v-icon>
                                </v-btn>
                            </td>
                        </tr>
                    </template>
                    <template v-slot:item.period="{ item }">
                        {{item.period|period_date}}
                    </template>
                    <template v-slot:item.status="{ item }">
                        {{ getStatus(item.status) }}
                    </template>
                    <template v-slot:item.action="{ item }">
                        <v-tooltip bottom open-delay="500">
                            <template v-slot:activator="{ on }">
                                <v-btn @click="editItem(item)" class="mr-2" icon v-on="on"><v-icon>mdi-pencil</v-icon></v-btn>
                            </template>
                            <span>Редактировать</span>
                        </v-tooltip>

                        <v-tooltip
                                bottom
                                open-delay="500"
                                class="custom-tooltip"
                                v-if="user.department.id == item.department"
                        >
                            <template v-slot:activator="{ on }">
                                <v-btn @click="duplicateItem(item)" class="mr-2" icon v-on="on"><v-icon>mdi-plus-circle-multiple-outline</v-icon></v-btn>
                            </template>
                            <span>Сделать копию отчета</span>
                            <div class="info1">У копии отчета период будет текущим, статус - Черновик</div>
                        </v-tooltip>

                    </template>
                    <template slot="no-data">
                        <v-btn color="primary" @click="initialize">Перегрузить</v-btn>
                    </template>
                </v-data-table>
                <div class="text-xs-center pt-2">
                    <v-pagination
                            key="pagination"
                            v-model="pagination.page"
                            :length="reports.last_page"
                    ></v-pagination>
                </div>
            </v-flex>
<!--            <router-view></router-view>-->
        </v-layout>
    </v-container>
</template>

<script>

export default {
  data () {
    return {
      headers: [
        {
          text: 'Период',
          align: 'start',
          sortable: false,
          value: 'period'
        },
        {
          text: 'Статус',
          align: 'start',
          sortable: false,
          value: 'status'
        },
        {
          text: 'Организация',
          align: 'start',
          sortable: false,
          value: 'department_name_short'
        },
        {
          text: 'Действие',
          align: 'start',
          sortable: false,
          value: 'action'
        }
      ],
      menuFilter: false,
      pagination: {
        rowsPerPage: 10,
        sortBy: null,
        totalItems: 0,
        page: 1
      }
    }
  },

  computed: {
    listLoading () {
      return this.$store.getters['common/listLoading']
    },
    reports () {
      return this.$store.getters['reportingReport/reports']
    },
    report_search () {
      return this.$store.getters['reportingReport/report_search']
    },
    statuses () {
      return this.$store.getters['reportingReport/statuses']
    },
    types () {
      return this.$store.getters['reportingReport/types']
    },
    report () {
      return this.$store.getters['reportingReport/report']
    },
    user () {
      return this.$store.getters['auth/user']
    }
  },
  watch: {
    pagination: {
      handler () {
        this.initialize()
      },
      deep: true
    }
  },
  methods: {
    initialize () {
      this.$store.dispatch('reportingReport/fetchReports', {
        pageId: this.pagination.page,
        report_search: this.report_search,
        typeAbbr: this.$route.params.typeAbbr
      })
    },
    editItem (item) {
      this.$router.push({ name: 'reporting_report', params: { 'report_id': item.id } })
    },
    duplicateItem (item) {
      this.$store.dispatch('reportingReport/duplicateReport', item.id)
        .then(() => {
          this.$router.push({ name: 'reporting_report', params: { 'report_id': this.report.id } })
          // this.$router.push({ name: 'reporting_list' })
        })
    },
    getStatus (id) {
      return this.$store.getters['reportingReport/getStatus'](id)
    },
    getType (typeAbbr) {
      return this.$store.getters['reportingReport/getType'](typeAbbr)
    }
  },
  created: function () {
    this.initialize()
  }
}
</script>
<style scoped>
  td, th {
    text-align: left;
    padding: 5px;
  }
  th {
    vertical-align: top
  }
  .custom-tooltip {
      opacity: 1!important;
  }
  .info1 {
      font-style: italic;
  }

</style>
